(function()
{
	//Import classes
	var BaseState = include('springroll.easeljs.BaseState'),
		OutsidePanel = include('Lemonade.OutsidePanel'),
		Delay = include('springroll.DelayedCall');

	/**
	 * The logic for the title state
	 * @class Lemonade.TitleState
	 * @extends springroll.easeljs.BaseState
	 */
	var OutsideState = function(options)
	{
		BaseState.call(this, new OutsidePanel(), options);

		this.bindEvents = this.bindEvents.bind(this);
		this.unbindEvents = this.unbindEvents.bind(this);
		this.onRoundIntroComplete = this.onRoundIntroComplete.bind(this);
		this.onRoundSuccess = this.onRoundSuccess.bind(this);
		this.onRoundFail = this.onRoundFail.bind(this);
		this.addMoneyToJar = this.addMoneyToJar.bind(this);
		this.nextRound = this.nextRound.bind(this);
		this.startTimeout = this.startTimeout.bind(this);
		this.stopTimeout = this.stopTimeout.bind(this);
	};

	//Extend the base state
	var p = extend(OutsideState, BaseState);

	/**
	 * After assets are loaded and state is fully entered
	 * @method  enterDone
	 */
	p.enterDone = function()
	{
		app.state = this;
		app.globalState.currentLocation = "Lemonade Stand Screen";

		// this.customerCount set in panel
		this.cupCount = 0;
		this.currentRound = 1;
		this.moneyCollected = 0;
		this.currentCoins = 0;
		this.tooManyCount = 0;
		this.tooFewCount = 0;

		this.tooFewTimeoutList = [
			"Click_Pitcher_1",
			"Click_Pitcher_2",
			"Click_Pitcher_3",
			"Click_OK_1",
			"Click_OK_2"
		];

		this.tooManyTimeoutList = [
			"Click_OK_1",
			"Click_OK_2"
		];

		this.panel.playIntroSequence();

		app.sound.play("ses-lem_outsideloop");

		this.componentStart = Math.round((Date.now() - app.globalState.startTime)/ 1000);
		GTM_obj.trackGTMEvent('gameComponentStart', {'componentType' : 'Simulation', 'componentName' : 'Counting'});

		this.roundStart = Math.round((Date.now() - app.globalState.startTime)/ 1000);
		GTM_obj.trackGTMEvent('gameRoundStart', {'roundNumber' : app.globalState.roundNumber});
	};

	p.bindEvents = function(includePitcher) {
		if (typeof includePitcher === "undefined") {
			includePitcher = true;
		}
		
		if (includePitcher) {
			this.panel.pitcher.on('click', this.addCup, this);
		}
		this.panel.skin.ok.on('click', this.serve, this);
	};

	p.unbindEvents = function() {
		this.panel.pitcher.removeAllEventListeners();
		this.panel.skin.ok.removeAllEventListeners();
	};

	p.onRoundIntroComplete =  function() {
		this.startTimeout();
		this.bindEvents();
	};

	p.addCup = function() {
		if (this.panel.gtmTimeoutStart > -1) {
			var duration = Math.round((Date.now() - app.globalState.startTime)/ 1000) - this.panel.gtmTimeoutStart;
			GTM_obj.trackGTMEvent('gameTOReEngage', {'duration' : duration});
			this.panel.gtmTimeoutStart = -1;
		}

		if (this.cupCount >= 8) {
			// can't add more than 8 cups
			return;
		}
		this.cupCount++;
		app.sound.play("ses-lem_pourlemonade");

		// clear out any highlights that may be waiting to fire
		createjs.Tween.removeTweens(this.panel.ok.highlight);
		this.panel.ok.highlight.alpha = 0;
		createjs.Tween.removeTweens(this.panel.pitcher.highlight);
		this.panel.pitcher.highlight.alpha = 0;
		
		this.startTimeout();

		this.panel.playCountAnim(this.cupCount);
	};

	p.serve = function() {
		if (this.panel.gtmTimeoutStart > -1) {
			var duration = Math.round((Date.now() - app.globalState.startTime)/ 1000) - this.panel.gtmTimeoutStart;

			GTM_obj.trackGTMEvent('gameTOReEngage', {'duration' : duration});
			this.panel.gtmTimeoutStart = -1;
		}
		
		app.voPlayer.stop();
		this.stopTimeout();

		app.sound.play("ses-lem_okbutton-press");

		// disable interaction while feedback is being provided
		this.unbindEvents();

		// clear out any highlights that may be waiting to fire
		createjs.Tween.removeTweens(this.panel.ok.highlight);
		this.panel.ok.highlight.alpha = 0;
		createjs.Tween.removeTweens(this.panel.pitcher.highlight);
		this.panel.pitcher.highlight.alpha = 0;

		if (this.cupCount == this.customerCount) {
			// success
			GTM_obj.trackGTMEvent('gameQuestionCA', {'questionAsked' : "How many cups of lemonade are needed for all of the monsters?", 
				'questionNumber' : this.currentRound, 'playerAnswer' : this.cupCount});
			this.panel.playCorrectAnim();
		} else if (this.cupCount < this.customerCount) {
			GTM_obj.trackGTMEvent('gameQuestionWA', {'questionAsked' : "How many cups of lemonade are needed for all of the monsters?", 
				'questionNumber' : this.currentRound, 'playerAnswer' : this.cupCount});
			// too few
			// this.tooManyCount = 0;
			this.tooFewCount++;

			if (this.tooFewCount > 3) {
				this.panel.playFinalIncorrect();
			} else {
				this.panel.playTooFewAnimation(this.tooFewCount);
			}

			
		} else {
			GTM_obj.trackGTMEvent('gameQuestionWA', {'questionAsked' : "How many cups of lemonade are needed for all of the monsters?", 
				'questionNumber' : this.currentRound, 'playerAnswer' : this.cupCount});
			// too many
			this.tooManyCount++;
			// this.tooFewCount = 0;

			if (this.tooManyCount > 3) {
				this.panel.playFinalIncorrect();
			} else {
				this.panel.playTooManyAnimation(this.tooManyCount);
			}
		}
	};

	p.onRoundSuccess = function() {
		this.currentRound++;

		this.tooManyCount = 0;
		this.tooFewCount = 0;
		
		this.panel.zoomIn();

		// add change to jar;
		this.moneyCollected += this.customerCount;
		this.panel.jar.gotoAndStop("coin" + this.moneyCollected + "_stop");

		app.animator.stopAll();

		app.voPlayer.play([
			500, 
			this.panel.currentMonsters[0].outro
		], this.addMoneyToJar);
	};

	p.onRoundFail = function(reset) {
		if (reset === true) {
			this.cupCount = 0;
			this.panel.cups.gotoAndStop(this.cupCount);
			this.panel.counter.gotoAndStop(this.cupCount);
		}

		if (this.tooManyCount > 3 || this.tooFewCount > 3) {
			// this was a final incorrect, don't re-enable the pitcher
			this.bindEvents(false);
		} else {
			this.bindEvents(true);
		}
		

		this.startTimeout();
	};

	p.addMoneyToJar = function() {
		if (this.currentCoins == this.moneyCollected) {
			createjs.Tween.get(this)
				.wait(1000)
				.call(this.nextRound);
		} else {
			this.currentCoins++;
			app.animator.play(this.panel.upclose.jar, "coin" + this.currentCoins, this.addMoneyToJar);
			app.sound.play("ses-lem_coinfall");
		}
	};

	p.nextRound = function() {
		this.panel.clearCustomers();

		this.cupCount = 0;
		this.panel.cups.gotoAndStop(this.cupCount);
		this.panel.counter.gotoAndStop(this.cupCount);

		if (this.currentRound <= 3) {
			this.panel.pitcher.gotoAndStop("round" + this.currentRound);
			this.panel.zoomOut();
			this.panel.setupRound();
			this.panel.playIntroSequence();

			var roundDuration = Math.round((Date.now() - app.globalState.startTime)/ 1000) - this.roundStart;
			GTM_obj.trackGTMEvent('gameRoundComplete', {'duration' : roundDuration, 
				'roundNumber' : this.currentRound-1});

			app.globalState.roundNumber++;
			
			this.roundStart = Math.round((Date.now() - app.globalState.startTime)/ 1000);
			GTM_obj.trackGTMEvent('gameRoundStart', {'roundNumber' : this.currentRound});
		} else {
			app.globalState.roundsCompleted++;
			this.panel.pitcher.gotoAndStop("complete");

			var duration = Math.round((Date.now() - app.globalState.startTime)/ 1000) - this.componentStart;
			GTM_obj.trackGTMEvent('gameComponentComplete', {'duration' : duration, 
				'componentType' : 'Simulation', 'componentName' : 'Counting'});

			this.nextState();
		}
	};

	p.startTimeout = function(resetCount) {
		// housekeeping and analytics tracking
		if (typeof resetCount === "undefined") {
			resetCount = true;
		}
		if (this.timeout) {
			this.timeout.destroy();
		}

		if (resetCount) {
			this.timeoutCount = 0;
		}

		// timer logic
		this.timeout = new Delay((function(){
			// set analytics vars
			app.state.timeoutCount += 1;

			if (app.voPlayer.playing) {
				// don't interrupt playing VO
				app.state.startTimeout(true); 
				return;
			}

			var newSequence = [], toIndex = 0, onPlayFunc = null;

			if (this.cupCount < this.customerCount) {
				// use pitcher prompts
				toIndex = (app.state.timeoutCount - 1) % this.tooFewTimeoutList.length;

				if (toIndex < 3) {
					onPlayFunc = function() {
						this.panel.highlightPitcher(0);
					}.bind(this);
				} else {
					onPlayFunc = function() {
						this.panel.highlightOk();
					}.bind(this);
				}

				newSequence.push({
					char: this.panel.grover,
					anim: app.config.animations.Grover[this.tooFewTimeoutList[toIndex]],
					onPlay: onPlayFunc,
					rig: "timeout"
				});
			} else {
				// just use ok button prompts
				toIndex = (app.state.timeoutCount - 1) % this.tooManyTimeoutList.length;
				onPlayFunc = function() {
					this.panel.highlightOk();
				}.bind(this);
				
				newSequence.push({
					char: this.panel.grover,
					anim: app.config.animations.Grover[this.tooManyTimeoutList[toIndex]],
					onPlay: onPlayFunc,
					rig: "timeout"
				});
			}

			this.panel.playAnimationSequence(newSequence, function(){
				app.state.startTimeout(false);
			});

			if (this.panel.gtmTimeoutStart < 0) {
				this.panel.gtmTimeoutStart = Math.round((Date.now() - app.globalState.startTime)/ 1000);
			}

			GTM_obj.trackGTMEvent('gameTimeoutPlay');
			
		}.bind(this)), 10000);
	};

	p.stopTimeout = function() {
		if (this.timeout) {
			this.timeout.destroy();
		}
		app.state.timeoutCount = 0;
		app.state.timeoutStartTime = 0;
	};

	/**
	 * When the state starts to exit, before transition
	 * @method  exitStart
	 */
	p.exitStart = function()
	{
		this.stopTimeout();
		app.animator.stopAll();
		createjs.Tween.removeTweens(this.panel.ok);
		createjs.Tween.removeTweens(this.panel.ok.highlight);
		createjs.Tween.removeTweens(this.panel.pitcher.highlight);
		createjs.Tween.removeTweens(this);
		app.voPlayer.stop();
		app.sound.stop("ses-lem_outsideloop");
	};

	//Assign to namespace
	namespace('Lemonade').OutsideState = OutsideState;
}());